const HOT_DEADLINE = new Date('2026-07-01 00:00:00').getTime();
const CURRENT_DATETIME = new Date().getTime();

/**
 * 判斷遊戲是否顯示 HOT 標籤
 * @param {object} game - 需含 img 欄位
 * @param {number} [now=Date.now()]
 */
export function isGameHot(game, now = CURRENT_DATETIME) {
  return (game?.img === 'hades' || game?.imgPath?.includes('hades')) && HOT_DEADLINE > now;
}

/**
 * 在遊戲物件上設定 hot 欄位
 */
export function applyGameHot(game, now = CURRENT_DATETIME) {
  return { ...game, hot: isGameHot(game, now) };
}
